import { Theme, WithStyles, withStyles } from "@material-ui/core";
import { StyleRules } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import {
  PresenterProps,
  withPresenter
} from "../../../../helpers/with-presenter";
import { CanViewPresenter } from "./can-view-presenter";

interface OwnProps extends WithStyles<"root"> {
  notAuthorized?: React.ReactNode;
  roles?: string[];
}

const styles = (theme: Theme): StyleRules => ({
  root: {}
});

@observer
class CanViewComponent extends React.Component<
  RouteComponentProps & OwnProps & PresenterProps<CanViewPresenter>
> {
  public render() {
    const { children, presenter, notAuthorized, roles } = this.props;
    let allowed = presenter.isAdmin;

    if (roles && roles.includes("public")) {
      allowed = true;
    }

    return allowed ? (
      <React.Fragment> {children}</React.Fragment>
    ) : (
      notAuthorized || null
    );
  }
}

export const CanView = withStyles(
  styles,
  {}
)(
  withRouter(
    withPresenter<CanViewPresenter, OwnProps & RouteComponentProps>(
      ({ history, match }, { interactor }) =>
        new CanViewPresenter(interactor.user),
      CanViewComponent
    )
  )
);
